const MODULE_NAME = 'FEELING_FACTORS';
const FEELING_FACTORS_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FEELING_FACTORS_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const FEELING_FACTOR_DELETE_STARTED = MODULE_NAME + 'DELETE_STARTED';
const FEELING_FACTOR_DELETE_COMPLETED = MODULE_NAME + 'DELETE_COMPLETED';

export {
  FEELING_FACTORS_FETCH_COMPLETED,
  FEELING_FACTORS_FETCH_STARTED,
  FEELING_FACTOR_DELETE_STARTED,
  FEELING_FACTOR_DELETE_COMPLETED
};
